<div bsModal [config]="{ backdrop: 'static', keyboard: false }" #registerUserModal="bs-modal" class="modal fade"
     tabindex="-1" role="dialog">
    <div class="modal-dialog modal-sm" role="document">
        <div class="modal-content" *ngIf="registerUserModal.isShown">
            <div class="modal-header loginmodal-header">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close"
                        (click)="registerUserModal.hide()"><span aria-hidden="true">&times;</span></button>
                <h4 class="modal-title">Regisztráció</h4>
            </div>
            <div class="loginmodal-container" style="max-width: 800px" *ngIf="registerView == 1">
                <div class="alert alert-danger alert-dismissible" *ngIf="registerError !== ''" [innerHTML]="registerError">
                </div>
                <form [formGroup]="registerUserFormGroup" class="form-horizontal">

                    <table class="tpadding-3">

                        <tr>
                            <td class="font-b">Név<span class="required">*</span>:</td>
                            <td><input pInputText type="text" formControlName="nev" id="nev" wFocusInput
                                       [modalObject]="registerUserModal" [(ngModel)]="user.nev"></td>
                            <td class="font-b">E-mail cím:</td>
                            <td><a href="mailto:{{user.email}}" class="fake-link"
                                   style="font-weight: bold">{{user.email}}</a></td>
                        </tr>


                        <tr>
                            <td class="font-b">Jelszó<span class="required">*</span>:</td>
                            <td><input pPassword type="password" feedback="false" formControlName="password"
                                       id="password"
                                       [(ngModel)]="user.password"></td>
                            <td class="font-b">Jelszó újra<span
                                class="required">*</span>:
                            </td>
                            <td><input pPassword type="password" feedback="false" formControlName="passwordre"
                                       id="passwordre" [(ngModel)]="user.passwordre"></td>
                        </tr>

                        <tr *ngIf="createClient">
                            <td class="font-b">Az ügyfél (szervezet) neve<span
                                class="required">*</span>:
                            </td>
                            <td><input pInputText type="text" formControlName="megnevezes" id="megnevezes" style="width: 200px"
                                       [(ngModel)]="user.megnevezes"></td>
                            <td class="font-b">Szervezet rövid neve<span
                                class="required">*</span>:
                            </td>
                            <td><input pInputText type="text" formControlName="rovidnev" id="rovidnev"
                                       [(ngModel)]="user.rovidnev"></td>
                        </tr>

                        <tr *ngIf="createClient">
                            <td class="font-b">Adószám<span class="required">*</span>:</td>
                            <td><input pInputText type="text" formControlName="adoszam" id="adoszam"
                                       [(ngModel)]="user.adoszam"></td>
                            <td class="font-b">Bankszámlaszám<span
                                class="required">*</span>:
                            </td>
                            <td><input pInputText type="text" formControlName="banksz" id="banksz" style="width: 200px"
                                       [(ngModel)]="user.banksz"></td>
                        </tr>

                        <tr *ngIf="createClient">
                            <td class="font-b">Cím<span class="required">*</span>:</td>
                            <td colspan="3">
                                <input pInputText type="text" formControlName="irsz" id="irsz" [(ngModel)]="user.irsz" style="width: 60px" placeholder="Irsz.">
                                <input pInputText type="text" formControlName="varos" id="varos" style="width: 120px; margin-left: 5px;" placeholder="Város"
                                       [(ngModel)]="user.varos">
                                <input pInputText type="text" formControlName="cim" id="cim" [(ngModel)]="user.cim" style="width: 180px; margin-left: 5px;" placeholder="Utca, házszám">
                            </td>
                        </tr>

                        <tr *ngIf="createClient">
                            <td class="font-b">Képviselő:</td>
                            <td><input pInputText type="text" formControlName="kepviselo" id="kepviselo"
                                       [(ngModel)]="user.kepviselo"></td>
                            <td class="font-b">Képviselő telefonszáma:</td>
                            <td><input pInputText type="text" formControlName="kepviselotel" id="kepviselotel"
                                       [(ngModel)]="user.kepviselotel"></td>
                        </tr>

                        <tr>
                            <td colspan="4" style="text-align: center"><input style="margin: 0 auto" type="submit" name="login"
                                                   class="login loginmodal-submit"
                                                   (click)="doRegisterUser()" value="Regisztráció"></td>
                        </tr>

                    </table>

                </form>

                <div class="login-help"><span class="required">*</span> Kötelező mezők</div>
            </div>

            <div class="loginmodal-container" style="max-width: 700px" *ngIf="registerView == 2">
                <div style="width: 500px; text-align: center; font-weight: bold; font-size: 16px">
                    A regisztráció sikeres volt, beléphet a rendszerbe!<br/>
                    <br/>
                    <input style="margin: 0 auto" type="submit" name="close" class="login loginmodal-submit"
                           value="Bezárás" (click)="registerUserModal.hide()">
                </div>
            </div>
        </div>
    </div>
</div>


<div bsModal [config]="{ backdrop: 'static', keyboard: false }" #forgotUserPasswordModal="bs-modal" class="modal fade"
     tabindex="-1" role="dialog">
    <div class="modal-dialog modal-sm" role="document">
        <div class="modal-content" *ngIf="forgotUserPasswordModal.isShown">
            <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close"
                        (click)="forgotUserPasswordModal.hide()"><span aria-hidden="true">&times;</span></button>
                <h4 class="modal-title">Elfelejtett jelszó</h4>
            </div>
            <div class="loginmodal-container" style="max-width: 550px; text-align: center;"
                 *ngIf="forgottenPwView == 1">
                <div class="alert alert-danger alert-dismissible" *ngIf="forgottenPwError !== ''">
                    {{forgottenPwError}}
                </div>
                <span style="font-size: 16px;">Kérem adja meg e-mail címét a jelszóemlékeztetőhöz.</span>
                <br/>
                <br/>
                <form>
                    <input type="text" name="user" [(ngModel)]="forgottenPw" style="width: 200px"
                           placeholder="E-mail cím" wFocusInput [modalObject]="forgotUserPasswordModal">
                    <input type="submit" name="requestPassword" class="login loginmodal-submit"
                           (click)="doForgotUserPassword()" value="Küldés" style="margin-left: 5px">
                </form>
                <br/>
            </div>
            <div class="loginmodal-container" style="max-width: 700px" *ngIf="forgottenPwView == 2">
                <div style="width: 550px; text-align: center; font-weight: bold; font-size: 16px">
                    A jelszó emlékeztető levelet elküldtük, kérem ellenőrizze postafiókját!<br/>
                    <br/>
                    <input style="margin: 0 auto" type="submit" name="close" class="login loginmodal-submit"
                           value="Bezárás" (click)="forgotUserPasswordModal.hide()">
                    <br/>
                </div>
            </div>

        </div>
    </div>
</div>


<div bsModal [config]="{ backdrop: 'static', keyboard: false }" #resetUserPasswordModal="bs-modal" class="modal fade"
     tabindex="-1" role="dialog">
    <div class="modal-dialog modal-sm" role="document">
        <div class="modal-content" *ngIf="resetUserPasswordModal.isShown">
            <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close"
                        (click)="resetUserPasswordModal.hide()"><span aria-hidden="true">&times;</span></button>
                <h4 class="modal-title">Elfelejtett jelszó</h4>
            </div>
            <div class="loginmodal-container" style="max-width: 550px; text-align: center;">
                <div class="alert alert-danger alert-dismissible" *ngIf="resetPwError !== ''">
                    {{resetPwError}}
                </div>
                <span style="font-size: 16px;">Kérem adja meg az új jelszót a hozzáféréshez!</span>
                <br/>
                <br/>
                <form>
                    <table class="tpadding-2 margin-0-auto" style="margin-bottom: 5px">
                        <tr>
                            <td class="right-content">Új jelszó:</td>
                            <td><input type="password" name="password" pPassword [(ngModel)]="resetNewPw"
                                       style="width: 150px" wFocusInput [modalObject]="resetUserPasswordModal"
                                       weakLabel="Gyenge" mediumLabel="Közepes" strongLabel="Erős" feedback="true"></td>
                        </tr>
                        <tr>
                            <td class="right-content">Új jelszó mégegyszer:</td>
                            <td><input type="password" name="passwordRe" pPassword [(ngModel)]="resetNewPwRe"
                                       style="width: 150px" weakLabel="Gyenge" mediumLabel="Közepes" strongLabel="Erős"
                                       feedback="true"></td>
                        </tr>
                    </table>
                    <input type="submit" name="requestPassword" class="login loginmodal-submit"
                           (click)="doResetPassword()" value="Küldés" style="margin: 0 auto">
                </form>
                <br/>
            </div>

        </div>
    </div>
</div>
